<template lang="html">

  <section class="wrapper cv-area">

    <div class="container">
      <h2 class="title-section">
        <span @click="toggleEdit">Idiomas</span>
        <button @click="toggleEdit" class="cv-action-button edit"
          v-if="!showedit && !noedit"></button>
        <button @click="showedit= false" class="cv-action-button close" v-if="showedit">✕</button>
      </h2>

      <div class="contenedor-idiomas">
        <template v-for="(idioma, key) in owndata" v-if="!!owndata">
          <p class="dato row-start" v-if="!showedit">
            <button @click="toedit(idioma)" class="editar" v-if="showedit"></button>
            <button @click="erase(idioma)" class="erase" v-if="showedit"></button>
            <strong>{{idioma.idioma}} - Nivel {{idioma.nivel}}</strong>
            <span v-if="idioma.descripcionCertificacion">{{idioma.descripcionCertificacion}}</span>
          </p>
          <idioma-edit :key="key" v-if="showedit" :data="idioma"></idioma-edit>
        </template>
        <template v-if="!showedit">
          <p v-if="!!!owndata & newlength == 0 & !noedit" class="zero-result">No tienes ningún idioma añadido pulsa <a @click="toggleEdit">{{(showedit) ? 'añadir' : 'editar'}}</a> para añadirlo</p>
          <p v-if="!!!owndata & newlength == 0 & noedit" class="zero-result">Sin idiomas añadidos</p>
        </template>
      </div>

      <div class="editor-idiomas column-start" v-if="showedit">
        <idioma-edit v-if="newlength != 0" :key="key" v-for="(el,key) in newlength"
          :new="true" v-model="newidioma[key]" @erase="erase"></idioma-edit>
        <button @click="newlength++" class="add-btn">Añadir nuevo</button>
        <button class="btn" @click="save" :loading="loading">Guardar</button>
      </div>

    </div>
  </section>

</template>

<script lang="js">

  import idiomaedit from '@/components/parts/idioma-edit';

  import {mapGetters, mapActions} from 'vuex';

  export default {
    name: 'idiomas',
    props : ['cvdata','noedit'],
    mounted(){
      this.setData();
    },
    components : {
      'idioma-edit' : idiomaedit
    },  
    data(){
      return{
        showedit : false,
        shownew : false,
        newidioma : [],
        newlength : 0,
        loading : false,
        owndata : ''
      }
    },
    methods:{
      ...mapActions(['editIdioma']),
      toggleEdit(){
        if(!this.noedit){
          this.showedit= !this.showedit
          this.newlength = 0;
        }

        if(!!!this.cvdata & this.showedit){
          this.newlength = 1;
        }
      },
      save(){
        
        if(this.newidioma.length != 0){
          
          this.loading = true;
          this.newidioma.forEach((i,key) => {
            this.editIdioma(i).then(r => {
              if(r){
                if(key+1 == this.newlength){
                  this.newidioma = [];
                  this.newlength = 0;
                  this.showedit = false;
                  this.shownew = false;
                  this.loading = false;
                }
              }
            })
          });
          
        }else{
          this.showedit = false;
          this.shownew = false;
        }
      },
      erase(value){
        this.newidioma = this.newidioma.filter(i => {i.idIdioma != value});
        this.newlength--;
      },
      toedit(idioma){
        this.editidioma = idioma;
      },
      setData(){
        this.owndata = '';
        setTimeout(e => {
          this.owndata = this.cvdata;
        },100)
      },
      addTosave(value){
        this.newidioma.push(value);
      }

    },
    computed : {
      ...mapGetters({
        dominios : 'getDominios'
      })
    },
    watch : {
            'cvdata': {
                deep: true,
                    handler(){
                        this.setData();
                    }
                }
        }
  }
</script>

<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/view-parts/espacio-personal/idiomas.vue